import React from 'react';

import Table from 'components/clarity-ui/components/table/table';
import TableHeader from 'components/clarity-ui/components/table/tableHeader';
import TableRow from 'components/clarity-ui/components/table/tableRow';
import TableData from 'components/clarity-ui/components/table/tableData';
import ComponentLoader from 'components/clarity-ui/components/componentLoader';

class WeightedLabelsTableComponent extends React.Component {

  renderTableRows (entityRecommendations, loading) {
    let tableRows = [];

    tableRows = entityRecommendations.map((item) => {
      const { name } = item;
      return (
        <TableRow key={name}>
          <TableData>{name}</TableData>
        </TableRow>
      );
    });

    if (tableRows.length === 0 || loading) {
      tableRows = [];
      tableRows.push(
        <TableRow key='empty-recommendations-table'>
          <TableData>No Recommendations found</TableData>
        </TableRow>
      );
    }

    return tableRows;
  }

  render () {
    const { entityRecommendations, loading } = this.props;
    return (
      <ComponentLoader loading={loading}>
        <Table scrollable>
          <thead>
            <TableRow isHeader>
              <TableHeader>Entity Recommendations</TableHeader>
            </TableRow>
          </thead>
          <tbody>
            { this.renderTableRows(entityRecommendations, loading) }
          </tbody>
        </Table>
      </ComponentLoader>
    );
  }
}

export default WeightedLabelsTableComponent;



// WEBPACK FOOTER //
// ./src/components/entityRecommender/queryResults/recommendationsTable.component.jsx